import axios from "axios";
import { ACTUALITE_URL } from "../../../../services/api/URL_API"
import { toast } from "react-toastify";
import Cookies from 'js-cookie';

const BASE_URL = 'http://127.0.0.1:8000'

const token = Cookies.get('token_admin')

export const GetActualite = async () => {
    
    try {
        const response = await axios.get(`${BASE_URL}${ACTUALITE_URL}`, {
			headers: {
				'Authorization': `Bearer ${token}`
			}
		});
        
        return  response.data.data
        
    } catch (error) {
        toast.error("Impossible de récupérer les actualités", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
}
